import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-status-traffic-light',
    templateUrl: './status-traffic-light.component.html',
    styleUrls: ['./status-traffic-light.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class StatusTrafficLightComponent implements OnInit {
    @Input() status: string = null;
    @Input() tooltip: string = null;

    constructor() { }

    ngOnInit(): void {
    }

}
